import { updateMessageContainerScroll, isMobile, uuid, setToken } from '../utils/utils';
import { ForwardRefRenderFunction, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import MessageContainer from './MessageContainer';
import styles from './style.module.less';
import { ConversationDetailType, MessageItem, MessageTypeEnum, AgentType } from './type';
import { queryAgentList } from './service';
import { useThrottleFn } from 'ahooks';
import Conversation from './Conversation';
import ChatFooter from './ChatFooter';
import classNames from 'classnames';
import { cloneDeep, isBoolean } from 'lodash';
import AgentList from './AgentList';
import MobileAgents from './MobileAgents';
import { HistoryMsgItemType, MsgDataType, SendMsgParamsType } from '../common/type';
import { getHistoryMsg, updataName } from '../service';
import { saveConversation } from './service';
import { DEFAULT_CONVERSATION_NAME } from './constants';
import ShowCase from '../ShowCase';
import { jsonParse } from '../utils/utils';
import { ConfigProvider, Drawer, Modal, Row, Col, Space, Switch, Tooltip } from 'antd';
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { debounce } from 'lodash';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import ToastUtils from '@/utils/ToastUtils';
import Toast from '@/components/Toast';
dayjs.locale('zh-cn');

type Props = {
    agentId?: any;
    skillId?: any;
    currentSessionMapIdRef?: any;
    linkToSession?: any;
    sessionListRef?: any;
    formatSessionList?: any;
    currentAgent?: AgentType;
    token?: string;
    agentIds?: number[];
    initialAgentId?: number;
    chatVisible?: boolean;
    noInput?: boolean;
    isDeveloper?: boolean;
    integrateSystem?: string;
    isCopilot?: boolean;
    onCurrentAgentChange?: (agent?: AgentType) => void;
    onReportMsgEvent?: (msg: string, valid: boolean) => void;
    onSelectConversation?: (conversation: ConversationDetailType, sendMsgParams?: any, isAdd?: boolean) => void;
    externalSessionId?: string;
    currentSessionMapIdList?: any;
    curSkill?: any;
    handlerJson?: any;
    setCurrentHandlerJson?: any;
    goLogin?: any;
    currentAgenticon?: any;
    userid?: any;
    isCanSendMsg?: any;
    checkIsLogin?: any;
};

const Chat: ForwardRefRenderFunction<any, Props> = (
    {
        agentId,
        skillId,
        token,
        agentIds,
        initialAgentId,
        chatVisible,
        noInput,
        isDeveloper,
        integrateSystem,
        isCopilot,
        onCurrentAgentChange,
        onReportMsgEvent,
        currentSessionMapIdRef,
        currentSessionMapIdList,
        linkToSession,
        formatSessionList,
        sessionListRef,
        externalSessionId,
        curSkill,
        handlerJson,
        goLogin,
        currentAgenticon,
        userid,
        isCanSendMsg,
        checkIsLogin
    },
    ref
) => {
    const params = useParams();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    let searchAgentId = searchParams.get('agentId');
    const paramsSessionId = params.sessionId;
    const [messageList, setMessageList] = useState<MessageItem[]>([]);
    const [inputMsg, setInputMsg] = useState('');
    const [pageNo, setPageNo] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [historyInited, setHistoryInited] = useState(false);
    const [currentConversation, setCurrentConversation] = useState<ConversationDetailType | undefined>(); //{ chatId: 0, chatName: '问答' }
    const [historyVisible, setHistoryVisible] = useState(false);
    const [agentList, setAgentList] = useState<AgentType[]>([]);
    const [currentAgent, setCurrentAgent] = useState<AgentType>();
    const [mobileAgentsVisible, setMobileAgentsVisible] = useState(false);
    const [agentListVisible, setAgentListVisible] = useState(true);
    const [showCaseVisible, setShowCaseVisible] = useState(false);

    const [isSimpleMode, setIsSimpleMode] = useState<boolean>(false);
    const [isDebugMode, setIsDebugMode] = useState<boolean>(true);
    //创建新对话
    const [shouldCreateNewConversation, setShouldCreateNewConversation] = useState(true);
    // 添加一个新的状态来跟踪聊天变化
    const [chatVisibilityChanged, setChatVisibilityChanged] = useState(false);
    const [isCreatingConversation, setIsCreatingConversation] = useState(false);
    const [isConversationSaved, setIsConversationSaved] = useState(false);
    const [isReceivingResponse, setIsReceivingResponse] = useState(false);
    const conversationRef = useRef<any>();
    const chatFooterRef = useRef<any>();
    const [session_id, setSession_id] = useState('');
    const [resCode, setResCode] = useState();
    const isNewSessionRef = useRef(true);
    const [isParsing, setIsParsing] = useState(false); //监控ai回答状态
    // useImperativeHandle，它允许我们在使用ref时自定义父组件能够访问的子组件实例
    useImperativeHandle(ref, () => ({
        onAddConversation,
        sendCopilotMsg,
        conversationRef,
        updateHistoryMsg, //暴漏历史方法函数
        createNewSession: () => {
            resetToNewConversation();
        }
    }));
    //强制更新对话状态
    const resetToNewConversation = () => {
        setShouldCreateNewConversation(true);
        setCurrentConversation(undefined);
        setIsConversationSaved(false); // 重置保存状态
        setChatVisibilityChanged((prev) => !prev);
    };
    const sendCopilotMsg = (params: SendMsgParamsType) => {
        setAgentListVisible(false);
        const { agentId, msg, modelId } = params;
        if (currentAgent?.id !== agentId) {
            setMessageList([]);
            const agent = agentList.find((item) => item.id === agentId) || ({} as AgentType);
            updateCurrentAgent({ ...agent, initialSendMsgParams: params });
        } else {
            onSendMsg(msg, messageList, modelId, params);
        }
    };

    const updateAgentConfigMode = (agent: AgentType) => {
        const toolConfig = jsonParse(agent?.toolConfig, {});
        const { simpleMode, debugMode } = toolConfig;
        if (isBoolean(simpleMode)) {
            setIsSimpleMode(simpleMode);
        } else {
            setIsSimpleMode(false);
        }
        if (isBoolean(debugMode)) {
            setIsDebugMode(debugMode);
        } else {
            setIsDebugMode(true);
        }
    };

    const updateCurrentAgent = (agent?: AgentType, needCreate?: boolean) => {
        setCurrentAgent(agent);
        onCurrentAgentChange?.(agent);
        localStorage.setItem('AGENT_ID', `${agent?.id}`);
        if (agent) {
            updateAgentConfigMode(agent);
            createAndSaveConversation(agent.id, needCreate);
        }
        if (!isCopilot && paramsSessionId && !searchAgentId) {
            window.history.replaceState({}, '', `${window.location.pathname}?agentId=${agent?.id}`);
        }
    };

    const initAgentList = async (needCreate?: boolean) => {
        const res: any = await queryAgentList();
        const agentListValue = (res.data || []).filter((item) => item.status === 1 && (agentIds === undefined || agentIds.includes(item.id)));

        setAgentList(agentListValue);
        if (agentListValue.length > 0) {
            const agentId = initialAgentId || localStorage.getItem('AGENT_ID');
            if (agentId) {
                const agent = agentListValue.find((item) => item.id === +agentId);
                updateCurrentAgent(agent || agentListValue[0], needCreate);
            } else {
                updateCurrentAgent(agentListValue[0], needCreate);
            }
        }
    };
    const createAndSaveConversation = async (agent, needCreate?: boolean) => {
        // 如果已经有 sessionid，不创建新会话，而是加载历史会话
        if (currentSessionMapIdRef.current) {
            // 加载历史会话
            setIsConversationSaved(true);
            // 触发历史消息加载
            setTimeout(() => {
                updateHistoryMsg(1);
                setPageNo(1);
            }, 0);
            return;
        }
        if (!needCreate) {
            return false;
        }
        if (!isConversationSaved && currentConversation?.chatId !== -1 && !currentSessionMapIdRef.current) {
            const agent6Id = agentId || '';
            const skillIdData = skillId || '';
            const res: any = await saveConversation(DEFAULT_CONVERSATION_NAME, agent || 0, agent6Id, skillIdData);
            setResCode(res.code);
            let sessionid = res.data;
            if (sessionid) {
                setSession_id(sessionid);
                currentSessionMapIdRef.current = sessionid;
                linkToSession(`${sessionid}?agentId=${agent}`, { replace: true });
                let curList = sessionListRef.current ? sessionListRef.current : [];
                let data = [{ session_name: DEFAULT_CONVERSATION_NAME, time_range: '1', session_id: sessionid, skill_id: skillIdData }, ...curList];
                formatSessionList(data);
            }
            setIsConversationSaved(true);
        }
    };
    useEffect(() => {
        console.group();
        console.log('currentSessionMapIdRef', currentSessionMapIdRef);
        console.log('paramsSessionId', paramsSessionId);
        console.groupEnd();
        //每次切换会话或者点击技能的时候currentSessionMapIdRef是实时更新的
        //从会话切换到技能时，currentSessionMapIdRef是空的，但是同时触发了路由跳转和技能切换，会触发多次
        //所以当路由上的id和currentSessionMapIdRef.current都是空的时候，才新建会话

        if (!currentSessionMapIdRef?.current && !paramsSessionId) {
            initAgentList(true);
        }
        //切会话时，同时触发路由跳转，和修改技能类型，导致执行顺序不一致，会触发多次请求
        //切换会话的时候currentSessionMapIdRef马上发生变化(使组件重新加载)，随后路由改变使组件又重新加载
        //所以从路由参数中获取的sessionId和currentSessionMapIdRef.current一致时，才请求历史记录

        if (paramsSessionId && paramsSessionId === currentSessionMapIdRef?.current) {
            initAgentList(false);
        }
    }, []);

    useEffect(() => {
        if (token) {
            setToken(token);
        }
    }, [token]);
    //处理聊天界面可见性变化
    useEffect(() => {
        if (chatVisible) {
            inputFocus();
            updateMessageContainerScroll();
            if (!currentConversation) {
                resetToNewConversation();
            }
        }
        setChatVisibilityChanged((prev) => !prev);
    }, [chatVisible, currentConversation]);
    //处理当前对话变化
    useEffect(() => {
        if (currentConversation) {
            const { initialMsgParams, isAdd } = currentConversation;
            if (paramsSessionId === undefined) {
                inputFocus();
                if (initialMsgParams) {
                    onSendMsg(initialMsgParams.msg, [], initialMsgParams.modelId, initialMsgParams);
                    return;
                }
                sendHelloRsp();
                return;
            } else {
                updateHistoryMsg(1);
                setPageNo(1);
            }
        }
    }, [currentConversation]);
    //管理消息容器滚动事件监听
    useEffect(() => {
        if (historyInited) {
            const messageContainerEle = document.getElementById('messageContainer');
            messageContainerEle?.addEventListener('scroll', handleScroll);
        }
        return () => {
            const messageContainerEle = document.getElementById('messageContainer');
            messageContainerEle?.removeEventListener('scroll', handleScroll);
        };
    }, [historyInited]);
    //自动创建新对话
    useEffect(() => {
        if (!currentAgent || !shouldCreateNewConversation || isCreatingConversation) return;
        // 如果已经有当前会话，则跳过创建
        if (currentConversation) {
            setShouldCreateNewConversation(false);
            return;
        }

        const createNewConversation = async () => {
            setIsCreatingConversation(true);
            try {
                if (currentAgent.initialSendMsgParams) {
                    await conversationRef.current?.onAddConversation(currentAgent.initialSendMsgParams);
                } else {
                    await conversationRef.current?.onAddConversation();
                }
                setShouldCreateNewConversation(false);
            } catch (error) {
                setShouldCreateNewConversation(false);
            } finally {
                setIsCreatingConversation(false);
            }
        };

        createNewConversation();
    }, [currentAgent, shouldCreateNewConversation, currentConversation]);

    const sendHelloRsp = (agent?: AgentType) => {
        if (noInput) {
            return;
        }
        setMessageList([
            {
                id: uuid(),
                type: MessageTypeEnum.AGENT_LIST,
                msg: agent?.name || currentAgent?.name || agentList?.[0]?.name
            }
        ]);
    };

    const convertHistoryMsg = (list: HistoryMsgItemType[]) => {
        return list.map((item: HistoryMsgItemType) => ({
            id: item.questionId,
            questionId: item.questionId,
            type: MessageTypeEnum.QUESTION,
            msg: item.queryText,
            parseInfos: item.parseInfos,
            parseTimeCost: item.parseTimeCost,
            msgData: { ...(item.queryResult || {}), similarQueries: item.similarQueries },
            score: item.score,
            agentId: currentAgent?.id
        }));
    };
    //更新聊天历史消息
    const updateHistoryMsg = async (page: number, sessionIdToUse?: string) => {
        // 如果是临时对话，不加载历史消息
        if (currentConversation?.chatId === -1) return;
        if (!currentConversation) return;
        const sessionIdValue = sessionIdToUse || paramsSessionId || '0';
        //获取历史消息
        const res = await getHistoryMsg(page, parseInt(sessionIdValue));
        //转换历史消息合并到现有消息列表
        const { hasNextPage, list } = res?.data || { hasNextPage: false, list: [] };
        //状态更新
        const msgList = [...convertHistoryMsg(list), ...(page === 1 ? [] : messageList)];
        //初始化处理
        setMessageList(msgList);
        setHasNextPage(hasNextPage);
        if (page === 1) {
            if (list.length === 0) {
                sendHelloRsp();
            }
            updateMessageContainerScroll();
            setHistoryInited(true);
            inputFocus();
            // 设置是否为新会话（列表为空表示是新会话）
            if (typeof isNewSessionRef !== 'undefined') {
                isNewSessionRef.current = list.length === 0;
            }
        } else {
            const msgEle = document.getElementById(`${messageList[0]?.id}`);
            msgEle?.scrollIntoView();
        }
    };
    const { run: handleScroll } = useThrottleFn(
        (e) => {
            if (e.target.scrollTop === 0 && hasNextPage) {
                updateHistoryMsg(pageNo + 1);
                setPageNo(pageNo + 1);
            }
        },
        {
            leading: true,
            trailing: true,
            wait: 200
        }
    );

    const inputFocus = () => {
        if (!isMobile) {
            chatFooterRef.current?.inputFocus();
        }
    };

    const inputBlur = () => {
        chatFooterRef.current?.inputBlur();
    };
    const onSendMsg = async (msg?: string, list?: MessageItem[], modelId?: number, sendMsgParams?: SendMsgParamsType) => {
        const islogin = await checkIsLogin();
        if (!islogin) {
            return false;
        }
        if (resCode === 'A0128') {
            Toast.info('请登录');
            goLogin();
            return;
        }
        if (isParsing) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        const currentMsg = msg || inputMsg;
        if (currentMsg.trim() === '') {
            setInputMsg('');
            return;
        }
        const msgAgent = agentList.find((item) => currentMsg.indexOf(item.name) === 1);
        const certainAgent = currentMsg[0] === '/' && msgAgent;
        const agentIdValue = certainAgent ? msgAgent.id : undefined;
        const agent = agentList.find((item) => item.id === sendMsgParams?.agentId);

        if (agent || certainAgent) {
            updateCurrentAgent(agent || msgAgent);
        }
        // const filteredList = (list || messageList).filter(item => item.type !== MessageTypeEnum.AGENT_LIST);
        const msgs = [
            // ...filteredList,
            ...(list || messageList),
            {
                id: uuid(),
                msg: currentMsg,
                msgValue: certainAgent ? currentMsg.replace(`/${certainAgent.name}`, '').trim() : currentMsg,
                modelId: modelId === -1 ? undefined : modelId,
                agentId: agent?.id || agentIdValue || currentAgent?.id,
                type: MessageTypeEnum.QUESTION,
                filters: sendMsgParams?.filters
            }
        ];
        setMessageList(msgs);
        updateMessageContainerScroll();
        setInputMsg('');
        setIsReceivingResponse(true);
    };
    useEffect(() => {
        if (session_id) {
            console.log('获取到的 sessionid:', session_id);
        } else {
            console.log('未找到 sessionid');
        }
    }, [session_id]);
    const onInputMsgChange = (value: string) => {
        const inputMsgValue = value || '';
        setInputMsg(inputMsgValue);
    };

    const saveConversationToLocal = (conversation: ConversationDetailType) => {
        if (conversation) {
            if (conversation.chatId !== -1) {
                localStorage.setItem('CONVERSATION_ID', `${conversation.chatId}`);
            }
        } else {
            localStorage.removeItem('CONVERSATION_ID');
        }
    };
    const onSelectConversation = (conversation: ConversationDetailType, sendMsgParams?: SendMsgParamsType, isAdd?: boolean) => {
        // 防止重复选择同一个会话
        if (currentConversation?.chatId === conversation.chatId) {
            return;
        }
        // 更新当前会话状态
        setCurrentConversation({
            ...currentSessionMapIdList?.current,
            initialMsgParams: sendMsgParams,
            isAdd: isAdd ?? false
        });
        saveConversationToLocal(conversation);
        setTimeout(() => {
            if (conversation.chatId !== -1 && (paramsSessionId || session_id)) {
                updateHistoryMsg(1);
            } else {
                sendHelloRsp();
            }
        }, 0);
        setTimeout(() => {
            updateMessageContainerScroll();
        }, 0);
    };
    const onMsgDataLoaded = (data: MsgDataType, questionId: string | number, question: string, valid: boolean, isRefresh?: boolean) => {
        onReportMsgEvent?.(question, valid);
        if (!isMobile) {
            conversationRef?.current?.updateData(currentAgent?.id);
        }
        if (!data) {
            setIsReceivingResponse(false);
            return;
        }
        const msgs = cloneDeep(messageList);
        const msg = msgs.find((item) => item.id === questionId);
        if (msg) {
            msg.msgData = data;
            setMessageList(msgs);
        }
        if (!isRefresh) {
            updateMessageContainerScroll(`${questionId}`);
        }
        setIsReceivingResponse(false);
    };

    const onToggleHistoryVisible = () => {
        setHistoryVisible(!historyVisible);
    };

    const onAddConversation = () => {
        conversationRef.current?.onAddConversation();
        inputFocus();
        setHistoryVisible(false);
        setChatVisibilityChanged((prev) => !prev);
    };
    const onSelectAgent = (agent: AgentType) => {
        if (agent.id === currentAgent?.id) {
            return;
        }
        if (messageList.length === 1 && messageList[0].type === MessageTypeEnum.AGENT_LIST) {
            setMessageList([]);
        }
        updateCurrentAgent(agent);
        updateMessageContainerScroll();
        // 切换 Agent 时创建新对话
        resetToNewConversation();
    };

    const sendMsg = (msg: string, modelId?: number) => {
        onSendMsg(msg, messageList, modelId);
        if (isMobile) {
            inputBlur();
        }
    };

    const onCloseConversation = () => {
        setHistoryVisible(false);
    };
    const handleParseStateChange = (isParsing: boolean) => {
        setIsParsing(isParsing);
    };
    const chatClass = classNames(styles.chat, {
        [styles.mobile]: isMobile,
        [styles.historyVisible]: historyVisible
    });
    return (
        <ConfigProvider locale={locale}>
            <div className={chatClass}>
                <div className={styles.chatSection}>
                    <div className={styles.chatApp}>
                        {currentConversation && (
                            <div className={styles.chatBody}>
                                <div className={styles.chatContent}>
                                    {/* 生成的对话组件 */}
                                    <MessageContainer
                                        curSkill={curSkill}
                                        id="messageContainer"
                                        isSimpleMode={isSimpleMode}
                                        isDebugMode={isDebugMode}
                                        messageList={messageList}
                                        chatId={currentSessionMapIdRef.current}
                                        historyVisible={historyVisible}
                                        currentAgent={currentAgent}
                                        chatVisible={chatVisible}
                                        isDeveloper={isDeveloper}
                                        integrateSystem={integrateSystem}
                                        onMsgDataLoaded={onMsgDataLoaded}
                                        onSendMsg={onSendMsg}
                                        currentAgenticon={currentAgenticon}
                                        agent6Id={agentId}
                                        skillId={skillId}
                                        currentSessionMapIdRef={currentSessionMapIdRef}
                                        linkToSession={linkToSession}
                                        sessionListRef={sessionListRef}
                                        formatSessionList={formatSessionList}
                                        resCode={resCode}
                                        goLogin={goLogin}
                                        isNewSessionRef={isNewSessionRef}
                                        userid={userid}
                                        checkIsLogin={checkIsLogin}
                                        onParseStateChange={handleParseStateChange}
                                    />
                                    {!noInput && (
                                        // 对话输入框
                                        <ChatFooter
                                            inputMsg={inputMsg}
                                            resCode={resCode}
                                            goLogin={goLogin}
                                            chatId={currentSessionMapIdRef?.current}
                                            agentList={agentList}
                                            currentAgent={currentAgent}
                                            onToggleHistoryVisible={onToggleHistoryVisible}
                                            onInputMsgChange={onInputMsgChange}
                                            onSendMsg={sendMsg}
                                            onAddConversation={onAddConversation}
                                            onSelectAgent={onSelectAgent}
                                            checkIsLogin={checkIsLogin}
                                            onOpenAgents={() => {
                                                if (isMobile) {
                                                    setMobileAgentsVisible(true);
                                                } else {
                                                    setAgentListVisible(!agentListVisible);
                                                }
                                            }}
                                            onOpenShowcase={() => {
                                                setShowCaseVisible(!showCaseVisible);
                                            }}
                                            disabled={isReceivingResponse}
                                            ref={chatFooterRef}
                                            isCanSendMsg={isCanSendMsg}
                                            isParsing={isParsing}
                                            currentAgenticon={currentAgenticon}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    {/* 历史对话 */}
                    <Conversation
                        currentAgent={currentAgent}
                        currentConversation={currentConversation}
                        historyVisible={historyVisible}
                        onSelectConversation={onSelectConversation}
                        onCloseConversation={onCloseConversation}
                        ref={conversationRef}
                        agentId={agentId}
                        skillId={skillId}
                    />
                    {currentAgent &&
                        (isMobile ? (
                            <Drawer
                                title="showcase"
                                placement="bottom"
                                height="95%"
                                open={showCaseVisible}
                                className={styles.showCaseDrawer}
                                destroyOnClose
                                onClose={() => {
                                    setShowCaseVisible(false);
                                }}
                            >
                                <ShowCase agentId={currentAgent.id} onSendMsg={onSendMsg} />
                            </Drawer>
                        ) : (
                            <Modal
                                title="showcase"
                                width="98%"
                                open={showCaseVisible}
                                centered
                                footer={null}
                                wrapClassName={styles.showCaseModal}
                                destroyOnClose
                                onCancel={() => {
                                    setShowCaseVisible(false);
                                }}
                            >
                                <ShowCase height="calc(100vh - 140px)" agentId={currentAgent.id} onSendMsg={onSendMsg} />
                            </Modal>
                        ))}
                </div>
                <MobileAgents
                    open={mobileAgentsVisible}
                    agentList={agentList}
                    currentAgent={currentAgent}
                    onSelectAgent={onSelectAgent}
                    onClose={() => {
                        setMobileAgentsVisible(false);
                    }}
                />
            </div>
        </ConfigProvider>
    );
};

export default forwardRef(Chat);
